"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgChallenge = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6.5a1 1 0 0 1-.553.894L16 9.618v2.81L20.6 19h.4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h.445l4.244-5.877a1 1 0 0 1 1.622 0l2.134 2.955L14 12.428V4a.996.996 0 0 1 .997-1h.011c.165.001.32.043.457.115l4.982 2.49A1 1 0 0 1 21 6.5Zm-6 7.988L18.159 19H11.84L15 14.488ZM9.4 19l.831-1.187-1.73-2.397L5.91 19H9.4ZM16 5.618v1.764l1.764-.882L16 5.618Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgChallenge);
//# sourceMappingURL=SvgChallenge.js.map